import { useQuery } from '@tanstack/react-query'
import { Modal } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import { useAtom } from 'jotai'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {
  activeAnswerAtom,
  activeQuestionAtom,
  showAnswerPreviewModalAtom,
} from 'store/atoms'
import { fetchAnswerImages } from 'store/queries'

function AnswerPreviewModal({ bookId }) {
  const { t } = useTranslation()
  const [answer] = useAtom(activeAnswerAtom)
  const [question] = useAtom(activeQuestionAtom)
  const [showAnswerPreviewModal, setShowAnswerPreviewModal] = useAtom(
    showAnswerPreviewModalAtom,
  )

  const questionId = question?.id
  const answerId = answer?.id

  const { data: images, isFetching } = useQuery({
    queryKey: ['images', { bookId, questionId, answerId }],
    queryFn: () => fetchAnswerImages(bookId, questionId, answerId),
  })

  return (
    <Modal
      title={
        t('a_story_from') + ' ' + answer?.first_name + ' ' + answer?.last_name
      }
      open={showAnswerPreviewModal}
      onCancel={() => setShowAnswerPreviewModal(false)}
      maskClosable={false}
      footer={false}
      wrapClassName="modal-story"
      getContainer={() => document.getElementById('story-section')}
    >
      <div className="story-preview">
        <br />
        <div style={{ maxWidth: '75%', margin: 'auto' }}>
          <h4>{question?.dsply_text}</h4>
        </div>
        <div
          style={{
            maxWidth: '75%',
            margin: 'auto',
            padding: '60px 20px 20px 20px',
          }}
        >
          <img
            alt="A section divider"
            src="divider.png"
            style={{ width: '100%' }}
          />
        </div>

        <div className="answer-content-wrapper p20 story-by">
          <h4 style={{ textAlign: 'left' }}>
            {t('by')}: {answer?.first_name + ' ' + answer?.last_name}
          </h4>
        </div>

        <div className="answer-content-wrapper modal-custom-body p20">
          <div
            className="answer-content"
            dangerouslySetInnerHTML={{
              __html: answer?.answer_text,
            }}
          />

          {isFetching ? (
            <StyledLoader />
          ) : (
            <div className="p20">
              {images?.map((ai) => (
                <>
                  <img
                    className="d-block mt-5"
                    src={ai.url}
                    alt="First slide"
                    style={{ width: '100%' }}
                  />
                  <p>{ai.caption}</p>
                </>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="modal-custom-footer">
        <div className="save-section actions text-right">
          <Button
            className="btn-white btn-dash"
            onClick={() => setShowAnswerPreviewModal(false)}
          >
            {t('close')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default AnswerPreviewModal
